import { useTranslation } from "react-i18next";
import Group from "@/components/atoms/Group";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";

/**
 * The value of the order drawer's "Quantity check" line: a ⚠ and what it means. Show it, with its label, only for an
 * order whose final amount was confirmed despite the backend's warning.
 */
export default function QuantityCheckValue() {
  const { t } = useTranslation();

  return (
    <Group gap={6} wrap="nowrap" align="center" data-testid="order-quantity-warning">
      <SVGAsset name="warning-triangle" width={14} height={14} alt="" />
      <Text size="sm">{t("orders:quantityCheck.drawerLine")}</Text>
    </Group>
  );
}
